import { ENDPOINT_UNSPLASH_DOWNLOAD_TRACKING } from '../config/endpoints'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export const trackDownload = async (downloadLocation: string): Promise<void> => {
  await AuthAxios.post(ENDPOINT_UNSPLASH_DOWNLOAD_TRACKING, {
    downloadLocation,
  })
}
